<template>
    <div class="backboard use-pointer" @click="backclick" :style="{ left: '0px', top: '0px', width: '100vw', height: '100vh', }">
        <div class="popupboard unselectable" @click="popupclick" :style="popupStyle">
            <div class="popupboard-scroller">
            <span class="popupboard-title wf-roundgothic" :style="{ color: titleColor, }">{{taglabel}}</span>
            <div class="popupboard-contents">
                <p v-if="message" class="wf-mincho" style="font-size: 1.2em; padding-left: 1rem; padding-right: 1rem;" v-html="messageString"></p>
                <p v-else class="wf-mincho" style="font-size: 1.2em; padding-left: 1rem; padding-right: 1rem;"><slot></slot></p>
                <br><p style="font-size: 0.9em; font-weight: bold; padding-left: 1rem; padding-right: 1rem;">{{onegaiString}}</p>
                <div ref="list-block" style="display: block; width: 90%; margin-left: auto; margin-right: auto;" v-show="existsListItems">
                    <div class="list-items" :style="{ width: listItemWidth }" v-if="inited" ref="sizeget">
                        <template v-if="existsListItems">
                            <template v-for="(value, key) in listItems">
                                <div
                                        class="list-item"
                                        :class="[key == activeItemKey ? 'active' : '']"
                                        :style="{ height: listItemHeight, paddingTop: '0px', paddingBottom: '1px'}"
                                        @click="handleClickItem(key)"
                                >
<!--                                    <slot v-bind:value="value">-->
                                        <div class="no-pointer" :style="{ display: 'flex', height: itemHeight, justifyContent: 'flex-start', alignItems: 'center' }">
                                            <template v-if="listKind == 'icon'">
                                                <img
                                                        v-if="hasIcon(value)"
                                                        :src="imageSource(value.icon)"
                                                        alt="icon"
                                                        :[srcsetTag(value.icon)]="imageSources(value.icon)"
                                                        :width="itemIconSize + 'px'"
                                                        :height="itemIconSize + 'px'"
                                                />
                                                <div
                                                        :style="{  marginLeft: '12px'}"
                                                >{{ value.exp }} </div>
                                            </template>
                                            <template v-else>
                                                <img
                                                        :[imageWidthTag]="value.imageWidth"
                                                        :[srcsetTag(value.image)]="imageSources(value.image)"
                                                        :align="imagePosition(value)"
                                                        :src="imageSource(value.image)"
                                                        alt="logo"
                                                        v-if="hasImage(value)"
                                                        :style="{ marginRight: '12px'}"
                                                />
                                                {{ value.name }}
                                            </template>
                                        </div>
<!--                                    </slot>-->
                                </div>
                            </template>
                        </template>
<!--                        <template v-else>-->
<!--                            <div class="list-item">-->
<!--                                選択肢がありません-->
<!--                            </div>-->

<!--                        </template>-->
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
  let debugOut = false

  export default {
    name: "LastpageSheet.vue",
    props: {
      ppwidth: {
        type: Number,
        default: null
      },
      ppheight: {
        type: Number,
        default: null
      },
      taglabel: {
        type: String,
        default: '最後のページです'
      },
      author: {
        type: String,
        default: '作者不詳'
      },
      title: {
        type: String,
        default: '名称未設定'
      },
      listItems: {
        type: Object,
        default: null,
      },
      listItemsInfo: {
        type: Object,
        default: null,
      },
      listKind: {
        type: String,
        required: false,
        default: 'plain'
      },
      activeItemKey: {
        type: [String, Number],
        required: false
      },
      itemWidth: {
        type: [Number, String],
        default: null
      },
      itemHeight: {
        type: [Number, String],
        default: null
      },
      itemIconSize: {
        type: Number,
        default: 40
      },
      font: {
        type: String,
        default: null
      },
      fontsize: {
        type: Number,
        default: null
      },
      fontweight: {
        type: String,
        default: null
      },
      buyaction: {
        type: Function,
        required: true
      },
      message: {
        type: String,
        default: null,
      },
      onegai: {
        type: String,
        default: null,
      },
      edgeColor: {
        type: String,
        default: '#230d04',
      },
      titleColor: {
        type: String,
        default: '#f6f7ff',
      },
    },
    data() {
      return {
        inited : false,
      };
    },
    created() {
      debugOut = this.$root.$options.debugOut
    },
    computed: {
       popupStyle() {
        return {
          '--ppwidth': (this.isNumber(this.ppwidth) ? this.ppwidth + 'px' : '90vw'),
          '--ppheight': (this.isNumber(this.ppheight) ? this.ppheight + 'px' : '90vh'),
          '--edge-color': this.edgeColor,
        }
      },
      existsListItems() {
        if (debugOut) {console.log(this.listItems)}
        return this.listItems && Object.keys(this.listItems).length },
      imageWidthTag(v) { return !v.hasOwnProperty("imageWidth") ? "listItemWidth" : null },
      // iconColor() { return this.defUIIconColor },
      // vdFont() { return this.font == null ? null : "font-family" },
      // vdFontSize() { return this.fontsize == null ? null : "font-size" },
      // vdFontWeight() { return this.fontweight == null ? null : "font-weight" },
      // centerHeight () { return this.pxheight / 2 },
      listItemWidth() {
        let r = this.itemWidth || this.popupWidth * 0.5
        return this.isNumber(r) ? `${(r > 240) ? r : 240}px` : r
      },
      listItemHeight () {
        return this.itemHeight != null
            ? this.isNumber(this.itemHeight) ? `${this.itemHeight}px` : this.itemHeight
            : (this.listKind === 'icon') ? '40px' : '60px'
      },
      // sizeStyleAppend () {
      //   return {
      //     width: this.isNumber(this.width) ? `${this.width}px` : this.width,
      //     height: this.isNumber(this.height) ? `${this.height}px` : this.height
      //     // 'var_width': `260px`,
      //     // 'var_height': `40px`
      //   }
      // },
      messageString() {
        return  this.message
      },
      onegaiString() {
         if (this.onegai) {
           return this.onegai.replace(/#author#/g,this.author).replace(/#title#/g,this.title)
         }
         return this.existsListItems ? `${this.author}著の「${this.title}」をお読みいただきありがとうございます。続きが気になったら、ぜひ下記よりのご購入をご検討願います。` : null
      },
    },
    methods: {
      backclick() {
        this.$emit('hide')
      },
      popupclick() {
        this.$emit('hide')
      },
      handleClickItem(key) {
        if (key === this.activeItemKey) return
        this.buyaction(key);
      },
      hasImage(v) {
        return v.hasOwnProperty("image")
      },
      hasIcon(v) {
        return v.hasOwnProperty("icon")
      },
      imagePosition(v) {
        return v.imageAlign || "left"
      },
      isSVG(name) {
        //  if (debugOut) {console.log(`'${name}' extension is '${name.substring(name.lastIndexOf('.')+1)}' `)}
        return name.substring(name.lastIndexOf('.')+1).toUpperCase() == 'SVG'
      },
      srcsetTag(name) {
        return this.isSVG(name) ? null : 'srcset';
      },
      imageSource(name) {
        if (!name) return null
        return require("../assets/" + name)
      },
      imageSources(name) {
        if (!name) return null
        return (
            require("../assets/" + name) + " 1x, " +
            require("../assets/" + name.replace(/(.*)\.(jpe?g|gif|png)/g, "$1@2x.$2")) + " 2x, " +
            require("../assets/" + name.replace(/(.*)\.(jpe?g|gif|png)/g, "$1@3x.$2")) + " 3x"
        );
      },
    },
    mounted() {
      this.inited = true
    },
  }
</script>

<style lang="scss" scoped>
    .backboard {
        position: fixed;
        background: rgba(0,0,0,0.05);
        z-index: 100;
    }

    .popupboard-scroller {
        overflow-y: scroll;
        background-color: rgba(0,0,0,0);
        padding: 1%;
        width: 98%;
        height: 98%;
    }

    .popupboard {
        position: fixed;
        margin: 0 0 4em 0;
        /*padding: 0.5em 1em;*/
        border: solid 3px var(--edge-color);
        border-radius: 8px 8px 8px 8px;
        text-align: left;
        background: #f6f7ff;
        z-index: 101;
        box-shadow: 0 2px 4px rgba(0,0,0,0.20);
        max-width: 46rem;

        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: var(--ppwidth);
        height: var(--ppheight);
    }
    .popupboard .popupboard-title {
        position: absolute;
        display: inline-block;
        top: -27px;
        left: 8px;
        padding: 0 9px;
        height: 25px;
        line-height: 25px;
        font-size: 17px;
        background: var(--edge-color);
        /*color: #f6f7ff;*/
        font-weight: bold;
        border-radius: 5px 5px 0 0;
    }

    .popupboard-contents {
        margin: 0;
        padding: 0.5em 1em;
    }

    .list-items {
        max-height: 300px;
        background-color: #fff;
        border-radius: 6px;
        border: 1px solid #b9bfc9;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
        /*position: absolute;*/
        /*left: 1px;*/
        margin-left: auto;
        margin-right: auto;
        overflow-y: scroll;
        z-index: 51;
        padding: 0.5rem 0;
        .list-item {
            color: #333;
            font-size: 14px;
            line-height: 16px;
            padding: 0.75rem 1rem;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            position: relative;

            &:not(.active):hover {
                background-color: #f3f4f6;
                cursor: pointer;
            }

            &.active {
                color: #fff;
                background-color: #182a4b;
            }
        }
    }
    .wf-roundgothic { font-family: "M PLUS Rounded 1c"; }
</style>